var AddressParser = (function () {
    function AddressParser() {
    }
    AddressParser.prototype.formatAddress = function (address) {
        var addrString = '';
        if (address.unitNumber) {
            addrString = address.unitNumber + "/";
        }
        if (address.streetNumber) {
            addrString = "" + addrString + address.streetNumber;
        }
        addrString = addrString + " " + address.streetName + " " + address.streetType + ", " + address.suburb + " " + address.state + " " + address.postcode;
        return addrString;
    };
    AddressParser.prototype.fromAnex = function (anexAddress) {
        var result = {
            contractCodes: anexAddress.contractCodes,
            formattedAddress: anexAddress.formattedAddressString,
            latitude: anexAddress.latitude,
            levelNumber: anexAddress.levelNumber,
            levelType: anexAddress.levelTypeCode,
            longitude: anexAddress.longitude,
            lotNumber: anexAddress.lotNumber,
            nbnLocId: anexAddress.nbnLocId,
            newDevelopmentFee: anexAddress.newDevelopmentChargeApplies,
            postcode: anexAddress.postCode,
            serviceClass: anexAddress.serviceClass,
            serviceClassDescription: anexAddress.serviceClassDescription,
            state: anexAddress.stateTerritoryCode,
            streetName: anexAddress.roadName,
            streetNumber: anexAddress.roadNumber1,
            streetType: anexAddress.roadTypeCode,
            suburb: anexAddress.localityName,
            unitNumber: anexAddress.unitNumber,
            unitType: anexAddress.unitTypeCode,
            isLineInUse: anexAddress.isLineInUse,
        };
        return result;
    };
    AddressParser.prototype.fromSuperloop = function (slAddress, oldAddress) {
        var result = {
            formattedAddress: slAddress.formattedAddress,
            nbnLocId: slAddress.id,
            newDevelopmentFee: slAddress.newDevelopmentsChargeApplies,
            serviceClass: slAddress.serviceClass,
            serviceClassDescription: slAddress.serviceClassDescription,
            state: oldAddress.state,
            streetName: oldAddress.streetName,
            streetNumber: oldAddress.streetNumber,
            streetType: oldAddress.streetType,
            suburb: oldAddress.suburb,
            postcode: slAddress.postcode || oldAddress.postcode,
            unitNumber: slAddress.addressDetails.unitNumber,
            unitType: slAddress.unitTypeCode,
            levelNumber: slAddress.addressDetails.buildingLevel,
            isLineInUse: slAddress.isLineInUse,
            serviceLevelRegion: slAddress.serviceLevelRegion,
            poiID: slAddress.poiID,
            poiName: slAddress.poiName,
            lastUpdatedTimestamp: slAddress.lastUpdatedTimestamp,
            technologyType: slAddress.technologyType,
        };
        return result;
    };
    AddressParser.prototype.fromGooglePlace = function (place) {
        var unitNumber = this.parseComponent(place.address_components, 'subpremise');
        if (parseInt(unitNumber, 10)) {
            unitNumber = parseInt(unitNumber, 10);
        }
        if (!parseInt(unitNumber, 10) && unitNumber.indexOf(' ') > -1) {
            var unitParts = unitNumber.split(' ');
            unitParts.forEach(function (unitPart) {
                if (parseInt(unitPart, 10)) {
                    unitNumber = parseInt(unitPart, 10);
                }
            });
        }
        var streetNumber = this.parseComponent(place.address_components, 'street_number');
        var streetName = this.parseComponent(place.address_components, 'route')
            .split(' ')
            .slice(0, -1)
            .join(' ');
        var streetType = this.parseComponent(place.address_components, 'route')
            .split(' ')
            .pop();
        var suburb = this.parseComponent(place.address_components, 'locality');
        var state = this.parseComponent(place.address_components, 'administrative_area_level_1', 'short_name');
        var postcode = this.parseComponent(place.address_components, 'postal_code');
        var latitude = place.geometry.location.lat();
        var longitude = place.geometry.location.lng();
        var result = {
            formattedAddress: place.formatted_address,
            latitude: latitude,
            longitude: longitude,
            nbnLocId: '',
            postcode: postcode,
            state: state,
            streetName: streetName,
            streetNumber: streetNumber,
            streetType: streetType,
            suburb: suburb,
            unitNumber: "" + unitNumber,
        };
        return result;
    };
    AddressParser.prototype.parseComponent = function (components, componentType, property) {
        if (property === void 0) { property = 'long_name'; }
        if (!components.some(function (_) { return _.types.indexOf(componentType) > -1; })) {
            return '';
        }
        return components.filter(function (_) { return _.types.indexOf(componentType) > -1; })[0][property];
    };
    return AddressParser;
}());
export { AddressParser };
//# sourceMappingURL=AddressParser.js.map